/**
 * Helper function to determine redirect path after authentication.
 *
 * This function handles complex redirect logic by checking multiple sources
 * for the intended destination path:
 * 1. location.state.from - redirect path stored in navigation state
 * 2. location.state.redirectTo - alternative redirect path
 * 3. location.pathname - current pathname if it's a dashboard route
 * 4. defaultPath - fallback default path
 *
 * @param location - React Router location object (or compatible object)
 * @param defaultPath - Default path to redirect to if no valid path is found
 * @returns The redirect path to use after authentication
 */
export const getRedirectPath = (location, defaultPath = "/dashboard") => {
    // Check if there's a redirect path in location state
    if (location?.state?.from) {
        const fromPath = location.state.from;
        // If it's already a dashboard route, use it
        if (fromPath.startsWith("/dashboard")) {
            return fromPath;
        }
    }
    // Check if there's a redirectTo in location state
    if (location?.state?.redirectTo) {
        const redirectPath = location.state.redirectTo;
        if (redirectPath.startsWith("/dashboard")) {
            return redirectPath;
        }
    }
    // Check if current pathname is a dashboard route (for direct navigation)
    if (location?.pathname?.startsWith("/dashboard")) {
        return location.pathname + (location.search || "");
    }
    // Default to dashboard
    return defaultPath;
};
